import React from "react";
import "./Card.css";

const Card = ({ title, value, linkText, additionalInfo, valueColor }) => {
  return (
    <div className="card text-center">
      <h5 className="card-title">{title}</h5>
      <h3 className={`card-value ${valueColor ? valueColor : ""}`}>{value}</h3>
      <p className="card-link-text">{linkText}</p>
      {additionalInfo && (
        <small className={`card-additional-info ${valueColor === "text-danger" ? "negative" : ""}`}>
          {additionalInfo}
        </small>
      )}
    </div>
  );
};

export default Card;